module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-15-8b3158c838e318af01fd3cf2c91d0ce4.jpg";